import { getSidebarValues, setSidebarValues, SidebarValues } from './sidebar';
import Storage from 'app/common/lib/storage';
import { memberId } from '@trello/session-cookie';

export const setLocalStorageUser = (idMe = memberId) => {
  if (idMe) {
    Storage.set('idMe', idMe);
  }
};

setLocalStorageUser();

export interface LocalStorageValues {
  readonly sidebar: SidebarValues;
}

export const getState = (): LocalStorageValues => {
  return {
    sidebar: getSidebarValues() || ({} as SidebarValues),
  };
};

export const setState = (state: LocalStorageValues) => {
  setSidebarValues(state.sidebar);
};
